var map = {
	"./arrow_left_active.png": "Lnq6",
	"./arrow_left_active@2x.png": "tjsT",
	"./arrow_left_inactive.png": "dRMB",
	"./arrow_left_inactive@2x.png": "ynXi",
	"./arrow_right_active.png": "OCK3",
	"./arrow_right_active@2x.png": "tVy2",
	"./arrow_right_inactive.png": "nyvW",
	"./arrow_right_inactive@2x.png": "SxTr",
	"./bike_pin.png": "r7bw",
	"./bike_pin@2x.png": "38XQ",
	"./checkbox_not_selected.png": "P1rc",
	"./checkbox_not_selected@2x.png": "uF4O",
	"./checkbox_selected.png": "6Nc+",
	"./checkbox_selected@2x.png": "M3ry",
	"./create_order_button_icon.png": "gRFi",
	"./create_order_button_icon@2x.png": "M0v1",
	"./driver_pin.png": "+XVV",
	"./driver_pin@2x.png": "SYDX",
	"./driver_pin_alpha@2x.png": "qBhR",
	"./ikude_footer_logo.png": "sQcY",
	"./ikude_logo.png": "KQl4",
	"./img_waiting_bg.png": "RfBn",
	"./img_waiting_car.png": "tHhh",
	"./login_logo.png": "sC/+",
	"./login_logo@2x.png": "J39V",
	"./logo.png": "7Otq",
	"./mobile_url_copy.png": "03NM",
	"./mobile_url_copy_selected.png": "hU55",
	"./new_order_button.png": "lAm5",
	"./new_order_button@2x.png": "dMc5",
	"./runner_pin.png": "pqdG",
	"./runner_pin@2x.png": "Bnr3",
	"./url_copy.png": "eSrW",
	"./url_copy_selected.png": "+GV2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BEjn";


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.png$
// module id = BEjn
// module chunks = 1